import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
// local files
import { getInvitedEmployeeByToken, createNewInviteEmployee } from '../actions/employee'
import ModifiedTextInput from '../components/common/ModifiedTextInput'
import qs from 'query-string'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'
import { openErrorMessage } from '../actions/message'
import moment from 'moment'

class InvitationVerification extends PureComponent {
  constructor(props) {
    super(props)
    const parsed = qs.parse(props.location.search)
    this.state = {
      token: parsed.token,
      employee: {},
      isDriver: false,
      invite: {
        password: '',
        cpassword: '',
        pin: '',
        cpin: '',
      },
      error: false,
      driverPin: false,
      showSaveBtn: true,
    }
  }

  componentDidMount() {
    this.props
      .dispatch(getInvitedEmployeeByToken(this.state.token))
      .then((res) => {
        if (res.role.name === 'Delivery Driver') {
          this.setState({ employee: res, isDriver: true, showSaveBtn: false })
        } else {
          this.setState({ employee: res })
        }
      })
      .catch((err) => {
        // Handle any error that occurred in any of the previous
        // promises in the chain.
        this.setState({ error: true })
      })
  }

  onSubmit = () => {
    const { invite = {}, driverPin = false, token = '', employee = {} } = this.state
    const {
      password = '',
      pin = '',
      license = '',
      dlExpirationDate = '',
      vehicleMake = '',
    } = invite

    let valid = false

    if (driverPin) {
      if (license.length === 0) {
        return this.props.dispatch(openErrorMessage('Please specify a License number.'))
      }
      if (dlExpirationDate.length === 0) {
        return this.props.dispatch(
          openErrorMessage('Please specify a Drivers License Expiration Date.'),
        )
      }
      if (!moment(dlExpirationDate, 'YYYY-MM-DD').isAfter(moment())) {
        return this.props.dispatch(openErrorMessage('Please enter a valid Expiration Date.'))
      }
      if (vehicleMake.length === 0) {
        return this.props.dispatch(openErrorMessage('Please specify a Vehicle Make.'))
      }
      valid = true
    } else {
      valid = this.validateFirstStep()
    }

    if (valid) {
      let invitation = {
        email: employee.email,
        password: password || this.state.data.password,
        pin: pin || this.state.data.pin,
        companyId: employee.companyId,
        driversLicense: license,
        dlExpirationDate: dlExpirationDate,
        vehicleMake: vehicleMake,
        token: token,
      }

      return this.props.dispatch(createNewInviteEmployee(invitation)).then((res) => {
        this.props.history.push({
          pathname: '/thankyou',
          state: {
            firstname: employee.firstName,
          },
        })
      })
    }
  }

  onChange = (event) => {
    const { name, value } = event.target
    this.setState((prevState) => ({
      invite: {
        ...prevState.invite,
        [name]: value,
      },
    }))
  }

  switchToDriverDetails = () => {
    if (this.validateFirstStep()) {
      this.setState({
        showSaveBtn: true,
        driverPin: true,
      })
    }
  }

  onBack = () => {
    this.setState({ driverPin: false, showSaveBtn: false })
  }

  validateFirstStep = () => {
    const { invite = {} } = this.state
    const { password = '', cpassword = '', pin = '', cpin = '' } = invite

    if (password.length === 0) {
      this.props.dispatch(openErrorMessage('Please specify a password.'))
      return false
    }
    if (password !== cpassword) {
      this.props.dispatch(openErrorMessage('Password does not match'))
      return false
    }
    if (pin.length === 0) {
      this.props.dispatch(openErrorMessage('Please specify a pin.'))
      return false
    }
    if (pin !== cpin) {
      this.props.dispatch(openErrorMessage('Pin does not match'))
      return false
    }
    return true
  }

  render() {
    const {
      invite = {},
      error = false,
      driverPin = false,
      isDriver = false,
      showSaveBtn = true,
    } = this.state
    const {
      password = '',
      cpassword = '',
      pin = '',
      cpin = '',
      license = '',
      dlExpirationDate = '',
      vehicleMake = '',
    } = invite

    return (
      <Grid className="rightBlockLogin" item xs={11} sm={7} md={11} lg={7}>
        <div>
          <h1 className="big-header slim-heading">Employee Signup</h1>
        </div>
        {error ? (
          <div>
            <h1 className="slim-heading">Your token is either expired or invalid. </h1>
          </div>
        ) : (
          <Fragment>
            {!driverPin || !isDriver ? (
              <Fragment>
                <ModifiedTextInput
                  id="password"
                  placeholder="Password"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={password}
                  name="password"
                  type="password"
                />
                <ModifiedTextInput
                  id="cpassword"
                  placeholder="Confirm Password"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={cpassword}
                  name="cpassword"
                  type="password"
                />
                <ModifiedTextInput
                  id="pin"
                  placeholder="Pin"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={pin}
                  name="pin"
                />
                <ModifiedTextInput
                  id="cpin"
                  placeholder="Confirm Pin"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={cpin}
                  name="cpin"
                />
              </Fragment>
            ) : null}

            {driverPin ? (
              <Fragment>
                <ModifiedTextInput
                  id="license"
                  placeholder="Driver's License"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={license}
                  name="license"
                />
                <ModifiedTextInput
                  id="dlExpirationDate"
                  placeholder="Drivers License Expiration Date"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={dlExpirationDate}
                  name="dlExpirationDate"
                  type="date"
                />
                <ModifiedTextInput
                  id="vehicleMake"
                  placeholder="Set Vehicle Make"
                  margin="normal"
                  className="margin-top-medium"
                  onChange={this.onChange}
                  value={vehicleMake}
                  name="vehicleMake"
                />
              </Fragment>
            ) : null}
            {!showSaveBtn ? (
              <Fragment>
                <Button
                  className="float-right margin-top-medium"
                  id="login-button"
                  onClick={this.switchToDriverDetails}
                >
                  Next
                </Button>
              </Fragment>
            ) : (
              <Grid container>
                <Grid item xs={6} className="margin-top-medium">
                  {driverPin ? (
                    <Button className="float-right" id="login-button" onClick={this.onBack}>
                      Back
                    </Button>
                  ) : null}
                </Grid>
                <Grid item xs={6} className="margin-top-medium">
                  <Button onClick={this.onSubmit} className="float-right" id="login-button">
                    Save
                  </Button>
                </Grid>
              </Grid>
            )}
          </Fragment>
        )}
      </Grid>
    )
  }
}

const ContainerWithCustomTitle = (props) => {
  const SideHOC = SideCoverHOC(ContainerWithTitle(InvitationVerification, 'Employee Signup'))
  return <SideHOC heading="Employee Signup" {...props} />
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(ContainerWithCustomTitle)



// WEBPACK FOOTER //
// ./src/containers/InvitationVerification.js